import type { ToReviewFundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveToReviewFundingRequests = createApiThunk<ToReviewFundingRequestVM[], void>(
  "fundingRequests/retrieveToReviewFundingRequests",
  async (_: void, { extra: { adminRepository } }) => {
    const requests = await adminRepository!.getAll({ status: ["to_review"] });
    const response: ToReviewFundingRequestVM[] = [];
    for (const r of requests) {
      if (r.status === "to_review") {
        response.push(r);
      }
    }
    return response;
  },
);
